<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <div class="row">
        <div class="col-md-3 col-sm-6 col-xs-12" v-for="registro of registros"  :key="registro.id" v-if="registro.exibir">
          <div class="info-box bg-yellow">
            <span class="info-box-icon"><i :class="registro.icone"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">{{registro.label}}</span>
              <span class="info-box-number">{{registro.valor}}<small> {{registro.umedida}}</small></span>

              <div class="progress">
                <div class="progress-bar" style="width: 100%"></div>
              </div>
                  <span class="progress-description">
                    {{registro.hora}} - {{registro.data}}
                  </span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
      </div>

      <!-- /.col -->
      <!-- fix for small devices only -->
      <div class="clearfix visible-sm-block"></div>
    </div>
    <!-- /.row -->

    <div class="col-xs-12">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title"></h3>
          <div class="box-body">
            <div class="col-xs-12">
              <p class="text-center">
                <strong>{{producaoGraficoTitulo}}</strong>
              </p>
              <va-chart
                :chart-config='producaoGrafico' v-if="carregar"></va-chart>
            </div>
            <hr class="visible-xs-block">
          </div>
        </div>
        <small class="space"><b>ARCHEA</b></small>
      </div>
    </div>
    <!-- /.row -->

    <!-- Main row -->
    <div class="row">
    <!-- /.row -->
  </div>
  </section>
  <!-- /.content -->
</template>

<script>
import {db} from '../../firebase'
import VAChart from '../VAChart'

export default {
  components: {
    'va-chart': VAChart
  },
  data () {
    return {
      registros: {},
      carregar: false,
      pesquisa: {
        registrador: 2520,
        cnpj: '00000sd_012018'
      }
    }
  },
  firebase: {
    registros: {
      source: db.ref('registradoronline'),
      cancelCallback (err) {
        console.error(err)
      }
    }
  },
  computed: {
    producaoGrafico () {
      return this.$store.state.Relatorios.historico
    },
    producaoGraficoTitulo () {
      return this.$store.state.Relatorios.titulo
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  },
  methods: {

  },
  mounted () {
    this.$store.dispatch('createRelatorioGeracaoSeteDias', this.pesquisa)
    .then(response => {
      this.carregar = true
    })
    .catch((err) => {
      console.log(err)
    })
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?f97b9642